import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'

import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../utilities/currency/formatPrice'

import placeholderImage from '../../../assets/images/placeholder-image.png'
import _ from 'lodash'

class BkFlowRoomCardUpSellsCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      upSellRoomDescriptionExpanded: false
    }
  }

  handleToggleUpSellRoomDescription = () => {
    this.setState({
      upSellRoomDescriptionExpanded: !this.state.upSellRoomDescriptionExpanded
    })
  }

  render() {
    const {
      availabilityData,
      configData,
      currentUpSell,
      handleUpgradeEvent,
      roomGroup,
      selectedRoomRatePrice,
      totalNights,
      totalUpSells,
      urlData
    } = this.props

    const hotelLabels = configData.hotel.labels[0]

    let activeHotelCode = null
    let matchedProperty = null
    let upSellRoomRate = null
    let upSellRoomTypeCode = null
    let upSellRoomName = null
    let upSellRoomImage = placeholderImage
    let upSellRoomDescription = null
    let upSellRatePlanCode = null
    let upSellRatePlanName = null
    let upSellRatePrice = null
    let upSellRateCurrencyCode = null
    let upSellRateCurrencySymbol = null
    let upSellRateDifference = null
    let isUpSellRateLess = false
    let displayedPriceFrequency = 'per stay'

    if (
      !_.isEmpty(urlData) &&
      urlData.hotelCode
    ) {
      activeHotelCode = urlData.hotelCode
    }

    if (!_.isEmpty(configData)) {
      const configProperties = configData.hotel.options.properties

      matchedProperty = configProperties.find(function (property) {
        return property.hotelCode === String(activeHotelCode)
      })
    }

    if (matchedProperty) {
      if (matchedProperty.displayPricesTimeline) {
        displayedPriceFrequency = matchedProperty.displayPricesTimeline
      }
    }

    // Get roomType data from API availability
    const upSellRoomType = availabilityData[roomGroup][0].roomTypes.find(function (roomType) {
      return roomType.roomTypeCode === currentUpSell.roomTypeCode
    })

    // Get ratePlan data from upSellRoomType mapping
    if (
      upSellRoomType &&
      upSellRoomType.viewExtensions &&
      upSellRoomType.viewExtensions.roomRates
    ) {
      const upSellRoomRateData = upSellRoomType.viewExtensions.roomRates.filter(function (ratePlan) {
        return String(ratePlan.ratePlanCode) === String(currentUpSell.ratePlanCode)
      })

      if (
        upSellRoomRateData &&
        upSellRoomRateData[0]
      ) {
        upSellRoomRate = upSellRoomRateData[0]
      }
    }

    // Get roomRate data from API availability
    const upSellRatePlan = availabilityData[roomGroup][0].ratePlans.find(function (roomRate) {
      return roomRate.ratePlanCode === currentUpSell.ratePlanCode
    })

    // Set upSell render values if existing
    if (
      upSellRoomType &&
      upSellRoomRate &&
      upSellRatePlan
    ) {
      // Set Room Type Code
      if (upSellRoomType.roomTypeCode) {
        upSellRoomTypeCode = upSellRoomType.roomTypeCode
      }

      // Set Room Name
      if (
        upSellRoomType.roomDescription &&
        upSellRoomType.roomDescription.name
      ) {
        upSellRoomName = upSellRoomType.roomDescription.name
      }

      // Selected room image
      if (
        upSellRoomType.viewExtensions &&
        upSellRoomType.viewExtensions.roomTypeImages &&
        upSellRoomType.viewExtensions.roomTypeImages[0] &&
        upSellRoomType.viewExtensions.roomTypeImages[0].path
      ) {
        upSellRoomImage = upSellRoomType.viewExtensions.roomTypeImages[0].path
      }

      // Set Room Description
      if (
        upSellRoomType.roomDescription &&
        upSellRoomType.roomDescription.text
      ) {
        upSellRoomDescription = upSellRoomType.roomDescription.text
      }

      // Set Rate Plan Code
      if (upSellRoomRate.ratePlanCode) {
        upSellRatePlanCode = upSellRoomRate.ratePlanCode
      }

      // Set Rate Plan Name
      if (upSellRatePlan.ratePlanName) {
        upSellRatePlanName = upSellRatePlan.ratePlanName
      }

      if (
        upSellRoomRate.rates &&
        upSellRoomRate.rates[0] &&
        upSellRoomRate.rates[0].total
      ) {
        // Set Room Rate Price
        if (
          upSellRoomRate.rates[0].total.amountBeforeTax &&
          totalNights
        ) {
          if (displayedPriceFrequency === 'per stay') {
            upSellRatePrice = upSellRoomRate.rates[0].total.amountBeforeTax
          } else {
            upSellRatePrice = upSellRoomRate.rates[0].total.amountBeforeTax / totalNights
          }
        }

        // Set Room Rate Currency Code & Symbol
        if (
          upSellRoomRate.rates[0].total.currencyCode
        ) {
          upSellRateCurrencyCode = upSellRoomRate.rates[0].total.currencyCode
          upSellRateCurrencySymbol = getCurrencySymbol(upSellRateCurrencyCode)
        }
      }

      // Calculate difference price for room upgrade
      if (
        selectedRoomRatePrice &&
        upSellRatePrice
      ) {
        if (Number(upSellRatePrice) < Number(selectedRoomRatePrice)) {
          upSellRateDifference = formatPrice(selectedRoomRatePrice - upSellRatePrice, 2)
          isUpSellRateLess = true
        } else {
          upSellRateDifference = formatPrice(upSellRatePrice - selectedRoomRatePrice, 2)
        }
      }
    }

    return (
      <div
        className={totalUpSells > 2 ? "bk-flow-room__card-upsells-card multi-row" : "bk-flow-room__card-upsells-card"}
        key={'room-upsell-' + roomGroup + '-' + currentUpSell.roomTypeCode + '-' + currentUpSell.ratePlanCode}
      >
        {upSellRoomImage &&
        <div
          className="bk-flow-room__card-upsells-card-image u-bg-image"
          style={{backgroundImage: 'url(' + upSellRoomImage + ')'}}
        >
          <img
            className="u-element-hidden"
            src={upSellRoomImage}
            alt={'Upsell Room Image for ' + upSellRoomName}
          />
        </div>
        }

        <div className="bk-flow-room__card-upsells-card-content">
          {upSellRoomName && <h5>{upSellRoomName}</h5>}
          {upSellRatePlanName && <p className="u-remove-margin">{upSellRatePlanName}</p>}
          {upSellRateDifference &&
          <p className="price">
          <span className="u-font-bold">
            {upSellRateCurrencySymbol && upSellRateCurrencySymbol}
            {upSellRateDifference}
          </span>

            {displayedPriceFrequency === 'per stay' ? (
              isUpSellRateLess ? (
                hotelLabels && hotelLabels.lessPerStay ? hotelLabels.lessPerStay : 'Less Per Stay'
              ) : (
                hotelLabels && hotelLabels.morePerStay ? hotelLabels.morePerStay : 'More Per Stay'
              )
            ) : isUpSellRateLess ? (
              hotelLabels && hotelLabels.lessPerNight ? hotelLabels.lessPerNight : 'Less Per Night'
            ) : (
              hotelLabels && hotelLabels.morePerNight ? hotelLabels.morePerNight : 'More Per Night'
            )}

          </p>
          }
          { upSellRoomDescription &&
            <p className="description u-remove-margin">
              { upSellRoomDescription.length > 110 ?
                <Fragment>
                  {upSellRoomDescription.slice(0, 110)}
                  <span className={this.state.upSellRoomDescriptionExpanded ? "u-txt-read-more expanded" : "u-txt-read-more"}>{upSellRoomDescription.slice(110)}</span>
                  <span
                    onClick={() => this.handleToggleUpSellRoomDescription()}
                    className="u-txt-toggle-read-more u-font-small u-font-bold"
                  >
						        {this.state.upSellRoomDescriptionExpanded ? '... ' + hotelLabels.readLess : '... ' + hotelLabels.readMore}
					        </span>
                </Fragment>
              :
                upSellRoomDescription
              }
            </p>
          }
        </div>

        {
          upSellRoomTypeCode &&
          upSellRatePlanCode &&
          <div
            aria-roledescription="button"
            role="button"
            tabIndex={0}
            className="bk-flow-room__card-upsells-card-button btn btn-primary"
            onClick={() => handleUpgradeEvent(upSellRoomTypeCode, upSellRatePlanCode)}
          >
            {hotelLabels && hotelLabels.upgrade ? hotelLabels.upgrade : 'Upgrade'}
          </div>
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    activeStep: state.activeStepData.activeStep,
    availabilityData: state.availabilityData.availability,
    configData: state.configData.configuration,
    urlData: state.availabilityData.urlData,
  }
}

export default connect(mapStateToProps, null)(BkFlowRoomCardUpSellsCard)



// WEBPACK FOOTER //
// ./src/components/room/upsells/BkFlowRoomCardUpSellsCard.js